module.exports = __webpack_public_path__ + "static/media/v1.f90e3d78.jpg";